import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const IntroductionText = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('introductionText.bannerTitle')}
                path="/about-us"
            />

            <div className="about-us-page">
                {/* Tanıtım Metni */}
                <div className="about-intro-section" style={{ padding: '80px 0' }}>
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-6">
                                <div className="intro-card" style={{
                                    background: 'var(--card-bg)',
                                    borderRadius: '16px',
                                    padding: '50px',
                                    border: '2px solid var(--border-color)',
                                    height: '100%'
                                }}>
                                    <p className="about-intro-text" style={{ marginBottom: '20px', lineHeight: '1.8' }}>{t('aboutUs.intro.p1')}</p>
                                    <p className="about-intro-text" style={{ marginBottom: '0', lineHeight: '1.8' }}>{t('aboutUs.intro.p2')}</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="intro-card" style={{
                                    background: 'var(--card-bg)',
                                    borderRadius: '16px',
                                    padding: '50px',
                                    border: '2px solid var(--border-color)',
                                    height: '100%'
                                }}>
                                    <p className="about-intro-text" style={{ marginBottom: '20px', lineHeight: '1.8' }}>{t('aboutUs.intro.p3')}</p>
                                    <p className="about-intro-text" style={{ marginBottom: '0', lineHeight: '1.8' }}>{t('aboutUs.intro.p4')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Cta1
                    title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
                />
            </div>
        </div>
    );
};

export default IntroductionText;
